import { gateway } from "../../../gateway";

export const deleteEventDeliveryConfig = async (): Promise<{ deleted: boolean }> => {
  const response = await gateway.delete("/event-delivery/config");
  return response?.data?.data;
};
